<template>
  <div class="driverTaskDetail">
    <!-- <el-drawer size="70%" title="设置装货起点" :data="visible" :visible.sync="visible" :before-close="cancelModal"> -->
    <!-- <basic-container> -->
    <div class="checkbox-custom">
      <div class="label">装货起点自动签单：</div>
      <el-checkbox-group
        class="types"
        v-model="checkedValue"
        @change="changeSwitch"
      >
        <el-checkbox label="1">开启</el-checkbox>
        <el-checkbox label="0">关闭</el-checkbox>
      </el-checkbox-group>
      <div class="label" style="margin-left: 56px">自动装车间隔时长：</div>
      <el-input
        v-model="generalCargoInterval"
        @blur="handleChange"
        :step="1"
        step-strictly
        size="small"
        type="number"
        :min="0"
        :max="9999999"
        style="width: 254px"
        :controls="false"
        label="请输入 自动装车间隔时长"
      >
        <template #append> 分钟 </template>
      </el-input>
    </div>

    <!-- <el-switch v-model="setValue" active-value="1" inactive-value="0" @change="changeSwitch" active-text="是" inactive-text="否">
        </el-switch> -->
    <!-- </basic-container> -->
    <!-- <basic-container> -->
    <avue-crud
      ref="crud"
      :page.sync="page"
      :data="tableData"
      :table-loading="tableLoading"
      :option="option"
      @on-load="getPage"
      @refresh-change="refreshChange"
      @sort-change="sortChange"
      @search-change="searchChange"
    >
      <template slot="menuLeft" slot-scope="scope">
        <div class="table-header">
          <el-button type="primary" size="small" @click="add">新增</el-button>
          <div class="search-input">
            <div class="label">装货起点名称：</div>
            <el-input
              v-model="fenceName"
              @keyup.enter.native="search"
            ></el-input>
          </div>
        </div>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          icon="el-icon-delete"
          type="text"
          size="small"
          @click="delObj(scope.row)"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <!-- </basic-container> -->
    <fence
      v-if="mapVisible"
      :visible.sync="mapVisible"
      @close="closePosition"
      @getLocation="getLocation"
      :isFence="false"
      :fenceList="fenceList"
      :projectFence="this.info.electronicFence"
      :projectRange="this.info.electronicRange"
    ></fence>
    <newConfirm
      title="确定要删除吗？"
      desc="删除后，该装货地址的电子围栏设置将失去效用，请谨慎操作。"
      :visible.sync="delVisible"
      @confirm="delRow"
    ></newConfirm>
    <!-- </el-drawer> -->
  </div>
</template>

<script>
import {
  getProjectInfoSdkFencePage,
  saveGeneralCargoSdkFence,
  delFence,
} from "@/api/chain/projectinfo";
import fence from "./fence.vue";
import {
  updateGeneralCargoMode,
  updateGeneralCargoInterval,
} from "../../../api/chain/projectinfo";

export default {
  components: {
    fence,
  },
  props:['info'],
  data() {
    return {
      delVisible: false,
      curRow: {},
      fenceName: "",
      checkedValue: [],
      dialogForm: {},
      tableData: [],
      tableLoading: false,
      option: {
        searchShow: false,
        labelWidth: 110,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: "装货起点名称",
            prop: "fenceName",
            search: true,
            minWidth: 200,
            searchSpan: 8,
            searchLabelWidth: 110,
            overHidden: true,
          },
          // {
          //   label: "经纬度",
          //   prop: "fenceGps",
          //   minWidth: 130,
          //   overHidden: true,
          // },
          {
            label: "地址",
            prop: "fenceAddress",
            minWidth: 180,
            overHidden: true,
          },
          {
            label: "电子围栏（米）",
            prop: "fenceRange",
            minWidth: 80,
            overHidden: true,
          },
        ],
      },
      mapVisible: false,
      btnLoading: false,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      setValue: "0",
      fenceList: [],
      generalCargoInterval: 30,
      // info: {},
    };
  },
  created() {},
  mounted() {
    // this.info = JSON.parse(this.$route.query.info);
    this.dialogForm = this.info;
    this.generalCargoInterval = this.info.generalCargoInterval;
    this.setValue = this.info.generalCargoMode;
    this.checkedValue = [this.setValue];
  },
  methods: {
    search() {
      this.page.currentPage = 1;
      this.getPage(this.page, { fenceName: this.fenceName });
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getProjectInfoSdkFencePage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
            projectInfoId: this.info.id,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    cancelModal() {
      this.$emit("refreshChange");
      this.$emit("update:visible", false);
    },
    changeSwitch(val) {
      this.checkedValue.length > 1
        ? this.checkedValue.shift()
        : (this.checkedValue = [this.setValue]);
      console.info(this.checkedValue);
      if (this.setValue != this.checkedValue.join("")) {
        let param = {
          projectInfoId: this.info.id,
          generalCargoMode: this.setValue,
        };
        updateGeneralCargoMode(param)
          .then((res) => {
            this.$message.success("操作成功");
          })
          .catch(() => {
            this.setValue = this.setValue == "1" ? "0" : "1";
          });
      }
      this.setValue = this.checkedValue.join("");

      // this.getData(1);
    },
    add() {
      this.tableLoading = true;
      getProjectInfoSdkFencePage(
        Object.assign({
          size: -1,
          projectInfoId: this.info.id,
        })
      )
        .then((response) => {
          this.fenceList = response.data.data.records;
          this.tableLoading = false;
          this.mapVisible = true;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    getLocation(obj) {
      let data = JSON.parse(obj);
      let param = {
        projectInfoId: this.info.id,
        companyAuthId: this.info.companyAuthId,
        fenceName: data.fenceName,
        fenceRange: data.fenceRange,
        fenceGps: data.fenceGps,
        fenceAddress: data.fenceAddress,
      };
      //添加装货点
      saveGeneralCargoSdkFence(param).then((res) => {
        this.$message.success("新增装货点成功");
        this.getPage(this.page);
        this.mapVisible = false;
      });
    },
    closePosition() {
      this.mapVisible = false;
    },
    delRow() {
      delFence(this.curRow.id).then((data) => {
        this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.delVisible=false
        this.getPage(this.page);
      });
    },
    delObj(row) {
      this.curRow = row;
      this.delVisible = true;
      // delFence
      // let _this = this;
      // this.$confirm("是否确认删除此装货点？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(function () {
      //     return delFence(row.id);
      //   })
      //   .then((data) => {
      //     _this.$message({
      //       showClose: true,
      //       message: "删除成功",
      //       type: "success",
      //     });
      //     this.getPage(this.page);
      //   })
      //   .catch(function (err) {});
    },
    handleChange(val) {
      console.log(val, "val");
      // generalCargoInterval
      console.log(this.generalCargoInterval);
      let param = {
        projectInfoId: this.info.id,
        generalCargoInterval: this.generalCargoInterval,
      };
      updateGeneralCargoInterval(param).then((res) => {
        this.$message.success("自动装车间隔时间修改成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.checkbox-custom {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  .label {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
  /deep/.el-input__inner {
    border-right: none;
  }
}
/deep/.avue-crud__left {
  width: 100%;
}
/deep/.el-input-group__append {
  background: #fff;
  border-left: none;
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-input {
  display: flex;
  align-items: center;
  .label {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    white-space: nowrap;
  }
}
</style>
